export default {
    name: 'input-text',
    data () {
        return {
            model: this.value,
            focused: false,
        }
    },
    created() {
        this.$on('focus', () => {
            this.$refs.input.focus()
        })
    },
    computed: {
        empty() {
            return ! this.model
        }
    },
    props: {
        placeholder: String,
        name: String,
        disabled: {
            type: Boolean,
            default: false,
        },
        hasError: Boolean,
        value: String,
        type: {
            type: String,
            default: 'text',
        },
    },
    watch: {
        model(value) {
            this.$emit('update:value', value);
            this.$emit('input', value);
        },
        value(value) {
            this.model = value
        }
    },
    methods: {
        clear: function() {
            this.$nextTick(() => {
                this.$refs.input.focus()
            })

            this.model = null
        },
    },
}


// WEBPACK FOOTER //
// ./src/components/inputText/inputText.js